import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './RemoveAccountModalSheet.styles';
import { ModalSheet } from '@/components/UI/ModalSheet';
import { useResponsive } from '@/hooks/useResponsive';

type RemoveAccountModalSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

export function RemoveAccountModalSheet({
  isOpen,
  onClose,
  onSubmit,
}: RemoveAccountModalSheetProps) {
  const { t } = useTranslation();
  const { isDesktop } = useResponsive();

  return (
    <ModalSheet
      isOpen={isOpen}
      onClose={onClose}
      title={t('pages.cabinet.removing_account')}
      isInPortal
      isBodyScrollLocked={!isDesktop}
    >
      <S.Content>
        <S.Description>
          {t('pages.cabinet.removing_account_note_1')}
        </S.Description>
        <S.List>
          <li>{t('pages.cabinet.removing_account_note_2')}</li>
          <li>{t('pages.cabinet.removing_account_note_3')}</li>
          <li>{t('pages.cabinet.removing_account_note_4')}</li>
        </S.List>
      </S.Content>
      <S.SubmitButton
        appearance="red"
        isFullWidth
        borderRadius={14}
        onPointerDown={event => event.preventDefault()}
        onClick={onSubmit}
      >
        {t('pages.cabinet.remove_account')}
      </S.SubmitButton>
    </ModalSheet>
  );
}
